import React from 'react';

const services = [
    {
        title: 'Mimari Danışmanlık ve Vizyon',
        text: 'İster modern bir konut projesi ister fonksiyonel bir ticari alan hedefleyin; tasarımın her aşamasında teknik bir rehberlik sunuyoruz. Doğru zemin etüdünden, mekanın ruhuna uygun estetik dokunuşlara kadar her detayda vizyonunuzu profesyonel bir mimari disiplinle birleştirerek hayata geçiriyoruz.',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
            </svg>
        ),
    },
    {
        title: 'Proje Onay ve Finansal Süreç',
        text: 'Karşılıklı güvene dayalı iş ortaklığımızın ilk adımı olarak, projelerimizin resmileşme sürecini şeffaf bir ödeme planıyla yönetiyoruz. Toplam bütçenin %75\'lik kısmı sözleşme anında, kalan %25\'lik bakiye ise projenin tüm detaylarıyla eksiksiz teslimata hazır olduğu aşamada tahsil edilmektedir.',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
        ),
    },
    {
        title: 'Yerinde Analiz',
        text: 'En doğru tasarımı oluşturmanın temelinin, mekanı kendi dokusunda incelemek olduğuna inanıyoruz. Tasarım aşamasına geçiş yapan müşterilerimiz için ücretsiz yerinde analiz ve teknik keşif hizmeti sağlıyoruz. Alanın tüm avantajlarını ve kısıtlamalarını belirleyerek size en optimize edilmiş projeyi sunmak için ekibimizle dilediğiniz zaman randevu oluşturabilirsiniz.',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
        ),
    },
    {
        title: 'Optimize Maliyet ve Tekliflendirme',
        text: 'Hayalinizdeki mimari dönüşüm için hiçbir mali taahhüt altına girmeden kapsamlı bir teklif alabilirsiniz. Malzeme kalitesinden işçilik detaylarına kadar her kalemin açıkça belirtildiği, bütçenizi koruyan ve sürpriz maliyet barındırmayan size özel fiyatlandırma çalışmalarını titizlikle hazırlıyoruz.',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
        ),
    },
    {
        title: 'Planlı Teslimat ve Zaman Yönetimi',
        text: 'Mimari tasarım ve uygulama süreçlerimizde zaman, en değerli kaynağımızdır. Standart bir projenin tamamlanma süresi, kapsamına bağlı olarak ortalama 4 ile 8 hafta arasındadır. Mevsimsel etkiler veya özel malzeme tedarik süreçlerine göre bu takvim, iş kalitesinden ödün vermeden en hızlı sonuç için karşılıklı olarak güncellenmektedir.',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
        ),
    },
    {
        title: 'Koruma Standartları ve Bakım Rehberi',
        text: 'Teslim ettiğimiz projelerin uzun yıllar ilk günkü estetiğini ve yapısal sağlamlığını koruması için özel bakım talimatlarımız mevcuttur. Yüzeylerin temizliğinde asidik içerikli ağır kimyasallar kesinlikle kullanılmamalı, mobilya yerleşimlerinde yapı elemanlarına zarar vermeyecek koruyucu tercihler yapılmalıdır. Yapınızın ömrünü uzatmak için bu standartlara uyum kritik önem taşır.',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
            </svg>
        ),
    },
];

const Services = () => (
    <section className="services" id="hizmetler">
        <div className="services__container">
            <div className="services__header">
                <p className="section-eyebrow">Avantajlarımız</p>
                <h2 className="section-title">NEDEN BİZ?</h2>
            </div>
            <div className="services__grid">
                {services.map((s) => (
                    <div className="service-card" key={s.title}>
                        <div className="service-card__icon">{s.icon}</div>
                        <h3 className="service-card__title">{s.title}</h3>
                        <p className="service-card__text">{s.text}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default Services;
